import { defineMessages } from 'react-intl';

export default defineMessages({
  scanTypeGeneral: {
    defaultMessage: 'General',
    id: 'V36nRX',
    description: 'Insights > Reports > Barcode Scan Action Quick Reference > Filters > Barcodes General',
  },
  scanTypePresets: {
    defaultMessage: 'Custom Presets',
    id: 'vguE8c',
    description: 'Insights > Reports > Barcode Scan Action Quick Reference > Filters > Barcodes Custom Presets',
  },
  scanTypeShippingOrders: {
    defaultMessage: 'Shipping Orders',
    id: 'cLn6jU',
    description: 'Insights > Reports > Barcode Scan Action Quick Reference > Filters > Barcodes ShippingOrders',
  },
  scanTypePrintingDocuments: {
    defaultMessage: 'Printing Documents',
    id: 'gstBuT',
    description: 'Insights > Reports > Barcode Scan Action Quick Reference > Filters > Barcodes Printing Documents',
  },
  scanTypeNavigation: {
    defaultMessage: 'Navigation',
    id: 'gFlREj',
    description: 'Insights > Reports > Barcode Scan Action Quick Reference > Filters > Barcodes Navigation',
  },
  selectBarcode: {
    defaultMessage: 'Select Barcode',
    id: 'UYbrcc',
    description: 'Insights > Reports > Barcode Scan Action Quick Reference > Filters > Barcode Scan Action QuickRef > Select Barcode',
  },
  shouldShowHotkeysLabel: {
    defaultMessage: 'Hotkeys',
    id: 'VAALlm',
    description: 'Insights > Reports > Barcode Scan Action Quick Reference > Filters > Barcode Scan Action QuickRef > Hotkeys label',
  },
  shouldShowHotkeysText: {
    defaultMessage: 'Include in Report',
    id: '32C99x',
    description: 'Insights > Reports > Barcode Scan Action Quick Reference > Filters > Barcode Scan Action QuickRef > Include in Report',
  },
});
